import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotas: RouteConfig[] = [
	{
		path: 'alteracao-em-massa',
		name: 'Alteração em Massa',
		components: {
			default: () =>
				import('@/views/application/produtos/TelaDeEdicaoMultiplaDeProdutos.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'alteracao-em-massa' as TipoDeRecurso,
		},
	},
]

export default rotas